/**
 * ReadOnlyContext — forces the editor canvas into a non-editable preview
 * (used when previewing a past version, SiteSettingsDrawer → History).
 *
 * PageNode reads this to force `preview = true` regardless of zoom, skip
 * the y-grid binding/seed (the store is pre-seeded from the version
 * snapshot), and hide editing chrome (connection handles, "zoom in to
 * edit" hint). SitemapCanvas additionally disables xyflow interaction.
 */
import { createContext, useContext } from "react";

const ReadOnlyContext = createContext<boolean>(false);

export const ReadOnlyProvider = ReadOnlyContext.Provider;

export function useReadOnly(): boolean {
  return useContext(ReadOnlyContext);
}
